<template>
  <div class="product" @click="handleClick">
    <div v-if ="showQty && remainingQty>=0 && product.type==1" class="qty" v-bind:class="{ empty: remainingQty==0 }">{{remainingQty}}<span v-if="pendingQty >0">->{{pendingQty}}</span></div>
    <div v-if ="showQty && remainingQty<0 && product.type==1" class="qty" v-bind:class="{ empty: true }">0<span v-if="pendingQty >0">->{{pendingQty}}</span></div>
    <div>{{ itemName }}</div>
    <div
      v-if="showProvider && product.provider!=null"
      class="fs-14 secondary-text">
        {{providerName(product.provider)}}
    </div>
    <Category
      :category="product.category"
      :specificCategory="product.specificCategory"
      class="fs-14 secondary-text" />
    <div>
      <el-tag v-if="showInventoryName && inventoryName!=null"
        type="info"
        size="small"
        effect="dark">
        <span>
          {{inventoryName}}
        </span>
      </el-tag>
    </div>
    <span class="fs-14 secondary-text" v-if="product.type ==1 && showQty && quantityReserved>0">{{$t('reservation.qtyReservedField')}} {{ quantityReserved }}<br></span>
    <UnitFormatVolumeLabel v-if="product.type == 1" :unit="product.unit" :uvc="product.uvc" :format="product.format" :volume="product.volume"></UnitFormatVolumeLabel>
  </div>
</template>
<script>
import productUtils from '@/utils/portaus-utils';
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductUtil from '@/utils/product-util'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import Category from '@/components/product/category-txt';
export default {
  name: 'item-template',
	props: {
		product : Object,
    quantity : Object,
    inventory : Object,
    showQty : {
      type : Boolean,
      default : true
    },
    showInventoryName : {
      type : Boolean,
      default : true
    },
    showUnit : {
      type : Boolean,
      default : true
    },
    showProvider : {
      type : Boolean,
      default : true
    },
    volume : {
      type : Number
    },
    format : {
      type : Number
    }
	},
  data() {
    return {

    };
  },components: {
    UnitFormatVolumeLabel,
    Category,
  },
	methods: {
    handleClick () {
      return this.$emit('click', this.product);
    }
	},
	computed: {
    itemName(){
      return ProductUtil.getExtendedProductName(this.product);
    },
    inventoryName(){
      if(this.inventory==null)return null;
      return this.inventory.name;
    },
    sku(){
      return this.product.sku;

    },
    remainingQty(){
      if(this.quantity==null) return 0;
      return this.quantity.inStock;
    },
    pendingQty(){
      if(this.quantity==null) return 0;
      return this.quantity.pending - this.quantity.reservedDelayed;
    },
    quantityReserved(){
      if(this.quantity==null) return 0;
      return this.quantity.reserved;
    },
    ...mapGetters('inventoryProducts',['providerName']),
	},
  created(){

  },mounted(){
    // console.log(this.product);
    // console.log(this.inventory);
    // console.log(this.quantity);
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.product{
  line-height:20px;
  margin:10px;

  .qty{
    float:right;
    position:relative
  }
  .empty {
    color:red;
  }
}



</style>
